import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Optional } from '../../_common/components/input/FormLabel';

export const FormFieldOptional: FC = () => {
  const { t } = useTranslation();
  return <Optional>{t('common:optional')}</Optional>;
};
